$(function() {
  $(document).click(function (e) {
    $(".dropdown-list-container:visible").each(function(){
      // Hide the dropdown menu if clicking somewhere outside of its container.
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0) {
        $(this).closest(".collapse").collapse('hide');
      }
    });
  });
});